<template>
  <div class="lc3-login">
    <div class="login-card">
      <img src="@/assets/logo.png" class="login-card__logo" alt="LC3 Market">
      <h1 class="login-card__title">Abrir Caixa</h1>
      <p class="login-card__subtitle">Entre com o usuário da loja e o operador para começar.</p>

      <form @submit.prevent="login" class="mt-4">
        <div class="mb-3">
          <label for="cliente" class="form-label">Usuário da loja</label>
          <div class="input-icon-group">
            <i class="bi bi-shop"></i>
            <input class="form-control" required id="cliente" type="text" placeholder="Ex.: minhaloja" v-model="user.username" autocomplete="off">
          </div>
        </div>
        <div class="mb-3">
          <label for="operador" class="form-label">Operador</label>
          <div class="input-icon-group">
            <i class="bi bi-person-badge"></i>
            <input class="form-control" id="operador" required type="text" placeholder="Ex.: caixa1" v-model="user.operator" autocomplete="off">
          </div>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Senha do operador</label>
          <div class="input-icon-group">
            <i class="bi bi-lock"></i>
            <input class="form-control" id="password" required type="password" placeholder="••••••••" v-model="user.password">
          </div>
        </div>
        <div class="mb-4">
          <label for="valor_inicial" class="form-label">Valor inicial do caixa</label>
          <div class="input-icon-group">
            <i class="bi bi-cash-coin"></i>
            <input class="form-control" id="valor_inicial" type="number" step="0.01" placeholder="R$ 0,00" v-model="user.value">
          </div>
          <!-- Sem `required`: um operador só de estoque (sem permissão de
               vender) não abre caixa — o backend ignora este campo pra ele. -->
        </div>
        <button class="btn btn-primary w-100 py-2" type="submit">
          <i class="bi bi-box-arrow-in-right me-2"></i>Entrar
        </button>
      </form>

      <div class="text-center mt-4">
        <span class="login-card__version">LC3 Market PDV &mdash; v{{ version }}</span>
      </div>
    </div>

    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title"><i class="bi bi-exclamation-triangle-fill text-danger me-2"></i>Erro ao fazer login!</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{msn_feedback}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/services/http.js';
import { reactive, ref } from 'vue';
import { useAuth } from '@/services/auth.js';
import { infos } from '@/services/infos';
import router from '@/router';
import { Modal } from "bootstrap";

export default {
  name: 'LoginView',
  setup(props) {

    const auth = useAuth();
    const Infos = infos()
    const msn_feedback = ref('');
    let modal = '';
    const version = "0.1.0";

    const user = reactive({
      username:'',
      operator:'',
      value:'',
      password:''
    });

    function openModal(elemento) {
      const modalNovoProduto = document.getElementById(elemento);
      modal = new Modal(modalNovoProduto);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    const login = async () => {
      try {
        const {data} = await http.post('/login', user);
        auth.setToken(data.token);
        auth.setUser(user.username);
        auth.setOperator(user.operator);
        auth.setEdit(data.edit);
        auth.setPermissions(data);
        Infos.setBusiness(data.business);
        // Sem permissão de vender, não há caixa aberto (cashier_id null) —
        // cai direto na tela de estoque em vez da tela de venda.
        router.push({name: data.can_make_sale ? 'pdv' : 'estoque'});
      } catch (error) {
        msn_feedback.value = error?.response?.data
        openModal('modal_feedback');
      }
    }

    return {user, login, msn_feedback, version}

  }
}
</script>

<style scoped>
  .lc3-login {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    background: radial-gradient(circle at top, #1a3a57 0%, var(--header-bg) 55%, #0b1a2b 100%);
  }

  .login-card {
    width: 100%;
    max-width: 420px;
    background: var(--panel-bg);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
    padding: 2.5rem 2.25rem;
  }

  .login-card__logo {
    display: block;
    width: 180px;
    margin: 0 auto 1.5rem;
  }

  .login-card__title {
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--text-strong);
    text-align: center;
    margin-bottom: 0.35rem;
  }

  .login-card__subtitle {
    font-size: 0.9rem;
    color: var(--text-muted);
    text-align: center;
    margin-bottom: 0;
  }

  .login-card__version {
    font-size: 12px;
    color: var(--text-muted);
  }

  .input-icon-group {
    position: relative;
  }

  .input-icon-group i {
    position: absolute;
    top: 50%;
    left: 0.9rem;
    transform: translateY(-50%);
    color: var(--text-muted);
    pointer-events: none;
  }

  .input-icon-group .form-control {
    padding-left: 2.5rem;
    border-radius: var(--radius-sm);
  }

  .input-icon-group .form-control:focus {
    border-color: var(--brand);
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
  }
</style>
